export default __webpack_public_path__ + "static/media/marker-icon-red.598ffffc.png";